// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { textOverflowEllipsis } from "@eisinc/App/SharedStyles/GeneralStyles";
import { findLocationModalStyles } from "@eisinc/Overrides/Components/FindLocationModal";
import { RadioStyle } from "@insite/mobius/Radio";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import { css } from "styled-components";

findLocationModalStyles.spinner = {
    color: "primary.main",
    css: css`
        margin: auto;
    `,
};

findLocationModalStyles.modal = {
    sizeVariant: "large",
    cssOverrides: {
        modalTitle: css`
            padding: 10px 20px;
        `,
        modalContent: css`
            padding: 20px;
        `,
        modalBody: css`
            ${({ theme }: any) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css`
                            position: relative;
                            text-align: left;
                            height: 100%;
                            margin: 0;
                            max-width: 100%;
                        `,
                        null,
                        css`
                            min-width: 450px;
                            height: 92vh; // it doesn't override height in XDL model why ?
                            top: 20px;
                            box-shadow: ${theme?.shadows[3]};
                            max-width: 95%;
                            max-height: 92vh;
                        `,
                        null,
                        null,
                    ],
                    "min",
                )};
        `,
    },
};

findLocationModalStyles.searchTextField = {
    cssOverrides: {
        formField: css`
            input {
                padding-right: 25px !important;
                ${textOverflowEllipsis};
                &:focus {
                    padding-right: 32px !important;
                }
            }
        `,
    },
};

findLocationModalStyles.searchResultLinksAndDistanceGridItem = { width: [12, 9, 9, 9, 9] };

findLocationModalStyles.searchResultLinksAndDistanceContainer = {
    gap: 0,
    css: css`
        width: 75%;
        padding: 0;
        margin: 0;
    `,
};

findLocationModalStyles.searchResultLinksOffsetGridItem = { width: 1 };

findLocationModalStyles.searchResultGoogleMapsDirectionLinkGridItem = {
    width: 4,
    css: css`
        padding-left: 3.5px;
    `,
};

findLocationModalStyles.searchResultDistanceGridItem = { width: 5 };

findLocationModalStyles.searchResultsText = {};

findLocationModalStyles.distanceUnitOfMeasureGridItem = {
    width: 8,
    align: "middle",
    css: css`
        justify-content: flex-end;
    `,
};

findLocationModalStyles.distanceUnitOfMeasureRadioGroup = {
    css: css`
        display: flex;
        gap: 4px;
        flex-direction: row;
        ${RadioStyle} + ${RadioStyle} {
            margin-top: 0;
        }
    `,
};
